import { ClarionSpinner, ClarionSpinnerProps } from '@clarion/ClarionSpinner';
import { useEffect, useState } from 'react';

const DelayedSpinner = (props: ClarionSpinnerProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(timer);
  });

  return visible ? <ClarionSpinner {...props} /> : null;
};

export default DelayedSpinner;
